__turbopack_context__.v({
  "cmsPoster": "lXbRMa_cmsPoster",
  "filminfoPoster": "lXbRMa_filminfoPoster",
  "posterContainer": "lXbRMa_posterContainer",
  "sanityPoster": "lXbRMa_sanityPoster",
});
